import axios from "axios";
import { handleOfflineRequest } from "./offlineApi";
import { isOfflineMode } from "../components/constant";

function toAxiosResponse(config, result) {
  return {
    data: result.data,
    status: result.status || 200,
    statusText: "OK",
    headers: { "content-type": "application/json" },
    config,
    request: {},
  };
}

function toAxiosError(config, error) {
  const err = error instanceof Error ? error : new Error(String(error));
  err.config = config;
  err.isAxiosError = true;
  if (!err.response) {
    err.response = {
      status: 500,
      data: { message: err.message },
      headers: {},
      config,
    };
  }
  return Promise.reject(err);
}

/** Install axios + fetch shims so the UI never needs a real backend. */
export function enableOfflineMode() {
  if (!isOfflineMode()) return;

  axios.defaults.adapter = async (config) => {
    try {
      const result = handleOfflineRequest(config);
      return toAxiosResponse(config, result);
    } catch (error) {
      return toAxiosError(config, error);
    }
  };

  if (typeof window === "undefined" || window.__VISHWAS_FETCH_PATCHED__) return;
  window.__VISHWAS_FETCH_PATCHED__ = true;
  const originalFetch = window.fetch.bind(window);

  window.fetch = async (input, init = {}) => {
    const url = typeof input === "string" ? input : input?.url || "";

    // Keep Cloudinary / external CDNs on the real network (optional).
    // In offline demo we still short-circuit app API + relative /api calls.
    const isAppApi =
      url.includes("/api/") ||
      url.startsWith("offline://") ||
      (url.startsWith("/") && url.startsWith("/api"));

    const isExternalUpload =
      /cloudinary\.com|res\.cloudinary\.com/i.test(url);

    if (!isAppApi || isExternalUpload) {
      return originalFetch(input, init);
    }

    try {
      let body = init.body;
      if (typeof body === "string") {
        try {
          body = JSON.parse(body);
        } catch {
          /* keep string */
        }
      }
      const result = handleOfflineRequest({
        url,
        method: init.method || "GET",
        data: body,
        headers: init.headers,
      });
      return new Response(JSON.stringify(result.data), {
        status: result.status || 200,
        headers: { "Content-Type": "application/json" },
      });
    } catch (error) {
      const status = error?.response?.status || 500;
      const data = error?.response?.data || { message: error.message };
      return new Response(JSON.stringify(data), {
        status,
        headers: { "Content-Type": "application/json" },
      });
    }
  };

  // eslint-disable-next-line no-console
  console.info(
    "[VishwasPower] Frontend-only mode ON — companies, jobs, and forms save in this browser (localStorage)."
  );
}
